import React, { createContext, useContext, useState, useEffect } from "react";
import { allowsCategory } from "../util/cookieConsent";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (allowsCategory("functional")) {
      return localStorage.getItem("theme") || "light";
    }
    return "light";
  });

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
    if (allowsCategory("functional")) {
      localStorage.setItem("theme", theme);
    }
  }, [theme]);

  useEffect(() => {
    const onConsent = () => {
      if (!allowsCategory("functional") && theme !== "light") {
        setTheme("light");
      }
    };
    window.addEventListener("wv:cookie-consent", onConsent);
    return () => window.removeEventListener("wv:cookie-consent", onConsent);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
